import { render } from "./UnauthorizedIndex.vue?vue&type=template&id=da5a7e04"
import script from "./UnauthorizedIndex.vue?vue&type=script&lang=js"
export * from "./UnauthorizedIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__